export default __webpack_public_path__ + "static/media/demographic-card.fd72dce6.jpg";